import clsx from 'clsx'
import {ToolbarType, useLayout} from '../../core'
import {Toolbar} from './Toolbar'
import {PageTitleWrapper} from './page-title'

const ToolbarWrapper = () => {
  const {config, classes} = useLayout()
  if (!config.app?.toolbar?.display) {
    return null
  }

  const isPageTitleVisible = showPageTitle(
    config.app?.toolbar?.layout,
    config.app?.pageTitle?.display
  )

  return (
    <div
      id='fds_app_toolbar'
      className={clsx('app-toolbar', classes.toolbar.join(' '), config?.app?.toolbar?.class)}
    >
      <div
        id='fds_app_toolbar_container'
        className={clsx(
          'app-container',
          'app-toolbar-container',
          classes.toolbarContainer.join(' '),
          config.app?.toolbar?.containerClass,
          config.app?.toolbar?.minimize?.enabled ? 'app-toolbar-minimize' : '',
          {
            'container-fluid': config.app?.toolbar?.container === 'fluid',
            'container-xxl': config.app?.toolbar?.container === 'fixed',
          }
        )}
      >
        {true && <PageTitleWrapper />}
        <div
          className='subheader-separator subheader-separator-ver mt-2 mb-2 mr-4 ml-4 bg-gray-300'
          style={{
            height: '30px',
            lineHeight: '1.5',
            textAlign: 'left',
            fontSize: '13px !important',
            fontWeight: '400',
            marginTop: '0.5rem !important',
            marginBottom: '0.5rem !important',
            marginRight: '20px !important',
            marginLeft: '1rem !important',
            display: 'block',
            borderRadius: '2px',
            width: '1px',
          }}
        ></div>
        <Toolbar />
      </div>
    </div>
  )
}

const showPageTitle = (appToolbarLayout?: ToolbarType, appPageTitleDisplay?: boolean): boolean => {
  const viewsWithPageTitles = ['classic', 'reports', 'saas']
  if (!appToolbarLayout || !appPageTitleDisplay) {
    return false
  }

  return appPageTitleDisplay && viewsWithPageTitles.some((t) => t === appToolbarLayout)
}

export {ToolbarWrapper}
